/**
 * ============================================================
 * SBT 2026-2027 ティザーLP / スクロール連動シーケンス一式
 * ビルド不要（このファイルを Shopify の assets にそのまま置く）
 *
 * 収録スクリプト：
 *   1. sequence        : 連番画像のスクロールスクラブ描画
 *   2. sequence-text   : テキストの左右ワイプ（双方向）
 *   3. sequence-glow   : 背景光彩・SPオーバーレイの data属性ブリッジ
 *   4. sequence-marker : ボルト強調マーカー
 *
 * メルマガフォームは Shopify の {% form 'customer' %} が送信を担うため、
 * 静的HTML版にあった疑似送信スクリプト（newsletter.js）は同梱しない。
 * （preventDefault が実フォームの送信を阻害するため意図的に除外している）
 *
 * いずれもセクション単位（.sbt-sequence-wrapper）で独立初期化されるため、
 * セクションの並び替え・削除・重複配置をしても互いに干渉しない。
 * ============================================================
 */

/**
 * ボルトマーカーの座標テーブル（差し替えはここだけ）
 * セクション側の data-marker-key と対応する。
 *   frame : 何フレーム目か（1始まり）
 *   x, y  : キャンバス基準のパーセント座標（左上が 0,0）
 * PCとSPで画像の構図が異なるため別々に持つ。sp が空ならpcを流用する。
 */
window.SBT_MARKER_TRACKS = window.SBT_MARKER_TRACKS || {
  fork: {
    pc: [
      { frame: 19, x: 57.5, y: 28.4 },
      { frame: 24, x: 56.3, y: 35.2 },
      { frame: 28, x: 54.7, y: 43.8 },
      { frame: 33, x: 53.0, y: 52.4 },
      { frame: 38, x: 52.4, y: 56.0 },
      { frame: 41, x: 52.3, y: 56.1 }
    ],
    sp: [
      { frame: 19, x: 57.9, y: 31.3 },
      { frame: 23, x: 55.8, y: 40.7 },
      { frame: 26, x: 52.7, y: 50.8 },
      { frame: 29, x: 49.4, y: 60.2 },
      { frame: 33, x: 46.3, y: 69.7 },
      { frame: 38, x: 45.1, y: 74.5 },
      { frame: 47, x: 44.8, y: 75.5 }
    ]
  },
  stem: {
    pc: [
      { frame: 1, x: 55.0, y: 66.1 },
      { frame: 2, x: 55.0, y: 66.1 },
      { frame: 7, x: 54.5, y: 70.9 },
      { frame: 13, x: 53.2, y: 81.0 },
      { frame: 18, x: 52.4, y: 86.3 },
      { frame: 20, x: 52.4, y: 86.8 },
      { frame: 23, x: 52.3, y: 86.7 }
    ],
    sp: [
      { frame: 3, x: 35.4, y: 66.3 },
      { frame: 9, x: 33.5, y: 74.6 },
      { frame: 15, x: 31.4, y: 85.8 },
      { frame: 19, x: 30.8, y: 89.2 },
      { frame: 22, x: 30.2, y: 88.9 },
      { frame: 31, x: 30.2, y: 87.2 }
    ]
  }
};

/* ---------- sequence.js ---------- */
/**
 * スクロール連動 連番画像シーケンス
 * .sbt-sequence-wrapper 単位で完全に独立して初期化される（他セクションに依存しない）。
 * 設定値は全て data 属性経由（後日 Liquid 化する際にそのまま流用するため）。
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * ベースURLの正規化。
   * 管理画面への貼り付けミスを吸収する目的で、
   *  - 前後の空白を除去
   *  - 末尾のスラッシュを必ず1本にする（無ければ付ける／複数なら1本に畳む）
   * これにより「.../files」「.../files/」「.../files//」のどれを入力しても
   * 連結後に二重スラッシュにならない。
   * 注意：ベースURLは「ファイル名の直前まで（＝ディレクトリ）」を想定している。
   * 接頭辞（fork_pc_ 等）まで含めて入力するとここでスラッシュが挿入され壊れるため、
   * 接頭辞は必ず data-seq-prefix 側に入れること。
   */
  function normalizeBase(base) {
    if (!base) return '';
    var b = String(base).trim();
    if (!b) return '';
    return b.replace(/\/+$/, '') + '/';
  }

  /**
   * 連番画像のURLを組み立てる。
   * 形式： ベースURL + 接頭辞 + ゼロ埋め連番 + '.' + 拡張子
   * 例）https://cdn.shopify.com/s/files/1/0849/2636/5984/files/ + fork_pc_ + 001 + . + webp
   */
  function buildFramePath(base, prefix, ext, pad, index) {
    var num = String(index).padStart(pad, '0');
    return normalizeBase(base) + prefix + num + '.' + ext;
  }

  function preloadFrames(paths, onProgress) {
    var total = paths.length;
    var loaded = 0;
    var images = new Array(total);

    return new Promise(function (resolve) {
      paths.forEach(function (src, i) {
        var img = new Image();
        img.onload = img.onerror = function () {
          images[i] = img;
          loaded += 1;
          onProgress(loaded, total);
          if (loaded === total) resolve(images);
        };
        img.src = src;
      });
    });
  }

  function initSequence(wrapper) {
    var stage = wrapper.querySelector('.sbt-sequence-stage');
    var canvas = wrapper.querySelector('[data-seq-canvas]');
    var loader = wrapper.querySelector('.sbt-sequence-loader');
    var loaderText = wrapper.querySelector('[data-seq-loader-text]');
    var loaderBarFill = wrapper.querySelector('.sbt-sequence-loader__bar span');
    if (!stage || !canvas) return;

    var isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    var base = isMobile
      ? wrapper.dataset.seqBaseSp || wrapper.dataset.seqBasePc
      : wrapper.dataset.seqBasePc;
    // Shopify Files はフラット構造のため、PC/SPの出し分けはフォルダではなく
    // ファイル名の接頭辞で行う（例 fork_pc_0001.webp / fork_sp_0001.webp）。
    var prefix = (isMobile ? wrapper.dataset.seqPrefixSp || wrapper.dataset.seqPrefix : wrapper.dataset.seqPrefix) || '';
    var count = parseInt(wrapper.dataset.seqCount, 10) || 0;
    var ext = wrapper.dataset.seqExt || 'png';
    var pad = parseInt(wrapper.dataset.seqPad, 10) || 3;
    var vh = parseInt(wrapper.dataset.seqVh, 10) || 300;
    var start = parseFloat(wrapper.dataset.seqStart) || 0;

    if (!base || count < 1) return;

    // 拡大率・基準点はCSS変数として渡し、実際の適用（有効/無効やブレークポイント）はCSS側で制御する
    if (wrapper.dataset.seqScale) {
      canvas.style.setProperty('--visual-scale', wrapper.dataset.seqScale);
    }
    if (wrapper.dataset.seqOrigin) {
      canvas.style.setProperty('--visual-origin', wrapper.dataset.seqOrigin);
    }

    var ctx = canvas.getContext('2d');
    var frames = [];
    var currentFrame = -1;
    var ticking = false;

    // SPは製品画像を画面幅いっぱいに表示する。CSS Grid の auto 行だけでは
    // 「幅%指定のリプレイスド要素」の寄与サイズがブラウザの近似計算により
    // 正確な100%幅にならない（実測で約90%止まりになる）ため、
    // 画像読み込み後にJSで実測した幅とアスペクト比から高さを算出し、
    // .sbt-stage-grid の行の高さをCSS変数として直接渡す。
    var stageGrid = wrapper.querySelector('.sbt-stage-grid');
    var stageVisual = wrapper.querySelector('.sbt-stage-visual');
    var stageText = wrapper.querySelector('.sbt-stage-text');
    function syncMobileVisualHeight() {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;
      if (!stageGrid || !stageVisual || !canvas.width || !canvas.height) return;
      var visualWidth = stageVisual.getBoundingClientRect().width;
      if (!visualWidth) return;
      var ratio = canvas.height / canvas.width;
      var visualHeight = visualWidth * ratio;

      // .sbt-sequence-stage は 100vh 固定 + overflow:hidden のため、
      // 「テキストの高さ + 製品画像の高さ」がそれを超えると下端が見切れる。
      // 収まらないときだけ製品画像を縮小する（比率は維持したまま幅も詰める）。
      // 収まるときは何もしない＝画面幅いっぱいのまま。
      var stageHeight = stage.getBoundingClientRect().height;
      var textHeight = stageText ? stageText.getBoundingClientRect().height : 0;
      var rowGap = parseFloat(getComputedStyle(stageGrid).rowGap) || 0;
      var available = stageHeight - textHeight - rowGap * 2;
      if (available > 0 && visualHeight > available) {
        visualHeight = available;
        canvas.style.width = visualHeight / ratio + 'px';
      } else {
        canvas.style.width = '';
      }

      stageGrid.style.setProperty('--visual-row-h', visualHeight + 'px');
    }

    // SPは実物写真を sticky ステージ（100vh固定・overflow:hidden）の外へ移し、
    // sticky解除後に通常フローで下から現れるようにする。
    //
    // 重要：position:sticky の要素は「自身の高さ（100vh）ぶん」しか通常フローに
    // 場所を占有しない（scroll-scrub用に wrapper へ与えた 320vh 等の高さは
    // sticky の可動域を確保するためのものであり、通常フロー上のスペースには
    // ならない）。そのため .sbt-stage-proof を .sbt-sequence-wrapper の「内側」に
    // 追加しても、sticky が実際に解除されるより大幅に手前で重なって表示されて
    // しまう（実測して判明した不具合）。
    // 正しくは .sbt-sequence-wrapper の「外側」（次の兄弟要素）に配置する。
    // これにより通常フローでは wrapper（320vh）の直後に続くため、
    // sticky解除のタイミングとほぼ一致して自然に現れる。
    // wrapper 自体の高さは変更不要（scroll-scrub用の計算式もそのまま）。
    function relocateProofForMobile() {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;
      var proof = stage.querySelector('.sbt-stage-proof');
      if (!proof) return;
      proof.classList.add('sbt-stage-proof--standalone', 'sbt-container-page');
      wrapper.parentNode.insertBefore(proof, wrapper.nextSibling);
    }

    function drawFrame(index) {
      var img = frames[index - 1];
      if (!img || !img.naturalWidth) return;
      if (canvas.width !== img.naturalWidth || canvas.height !== img.naturalHeight) {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      currentFrame = index;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var rect = wrapper.getBoundingClientRect();
        var scrollableHeight = rect.height - window.innerHeight;
        var rawProgress = scrollableHeight > 0 ? -rect.top / scrollableHeight : 0;
        rawProgress = Math.min(1, Math.max(0, rawProgress));

        // data-seq-start より手前はフレーム1で静止し、テキスト演出を先に見せる
        var progress = start > 0 ? (rawProgress - start) / (1 - start) : rawProgress;
        progress = Math.min(1, Math.max(0, progress));

        var frameIndex = 1 + Math.round(progress * (count - 1));
        if (frameIndex !== currentFrame) drawFrame(frameIndex);
        ticking = false;
      });
    }

    if (!isReducedMotion) {
      wrapper.style.height = vh + 'vh';
    } else {
      wrapper.classList.add('is-static');
    }

    var paths = [];
    for (var i = 1; i <= count; i++) {
      paths.push(buildFramePath(base, prefix, ext, pad, i));
    }

    preloadFrames(paths, function (loaded, total) {
      var percent = Math.round((loaded / total) * 100);
      if (loaderText) loaderText.textContent = 'LOADING ' + percent + '%';
      if (loaderBarFill) loaderBarFill.style.width = percent + '%';
    }).then(function (images) {
      frames = images;

      drawFrame(isReducedMotion ? count : 1);
      canvas.classList.add('is-ready');
      syncMobileVisualHeight();
      relocateProofForMobile();
      if (loader) {
        loader.classList.add('is-hidden');
        setTimeout(function () {
          loader.hidden = true;
        }, 400);
      }

      if (!isReducedMotion) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
      window.addEventListener('resize', syncMobileVisualHeight);
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('.sbt-sequence-wrapper[data-seq-count]');
    wrappers.forEach(initSequence);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------- sequence-text.js ---------- */
/**
 * テキスト帯の登場/退場アニメーション（スクロール連動・双方向）
 * [data-reveal-group] 単位で完全に独立して初期化される。
 *
 * 祖先に .sbt-sequence-wrapper がある場合：そのスクロール進行度（0〜1）のうち
 * 0〜data-seq-start の区間を「テキスト演出ウィンドウ」として使い、
 * その中の相対位置（0〜1）を各行の --reveal-progress に変換する。
 *
 * .sbt-sequence-wrapper を持たない軽量セクション（UNI-HOLDなど、シーケンスなし）の場合：
 * グループ自身がビューポートへ入ってくる進み具合（0=画面下端に到達, 1=十分入った）を
 * 同じ0〜1のウィンドウ進行度として扱う。どちらの経路でも以降のロジックは共通。
 *
 * IntersectionObserver は使わない：下スクロールで出現、上スクロールで
 * 逆順に消えるのは、進捗を素直にスクロール位置へ連動させるだけで実現できる。
 *
 * data-reveal-delay  : ウィンドウ内での開始オフセット（0〜1、既定 0）
 * data-reveal-step    : 行ごとのディレイ幅（0〜1、既定 0.1）
 * data-reveal-duration: 1行のワイプに使う幅（0〜1、既定 0.35）
 * data-reveal-order   : 各 .sbt-text-reveal 要素に付与すると表示順を上書きできる（既定はDOM順）
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGroup(group) {
    var items = group.querySelectorAll('.sbt-text-reveal');
    if (!items.length) return;

    // data-reveal-standalone="true"：.sbt-sequence-wrapper の子孫であっても
    // ラッパー全体のスクロール進行度ではなく、自身が画面に入ってくる
    // タイミング（entrance方式）で反応させたい要素向け（例：sticky解除後に
    // 通常フローで現れる実物写真ブロックなど、ラッパー内の早い段階の
    // ウィンドウ（data-seq-start）とは無関係にフェードインさせたい場合）。
    // このフラグはPC/SPでレイアウトが分岐する要素（実物写真など）を想定しており、
    // PC側では従来通りの配置・常時表示のままにするため、PC幅ではフェードインを
    // 適用せず --reveal-progress を1（表示済み）に固定して終了する。
    var standalone = group.dataset.revealStandalone === 'true';
    if (standalone && window.innerWidth >= MOBILE_BREAKPOINT) {
      Array.prototype.forEach.call(items, function (el) {
        el.style.setProperty('--reveal-progress', 1);
      });
      return;
    }
    var wrapper = standalone ? null : group.closest('.sbt-sequence-wrapper');
    var windowEnd = 1;
    if (wrapper) {
      windowEnd = parseFloat(wrapper.dataset.seqStart);
      if (!windowEnd || windowEnd <= 0) windowEnd = 0.15;
    }

    var baseDelay = parseFloat(group.dataset.revealDelay);
    if (isNaN(baseDelay)) baseDelay = 0;
    var step = parseFloat(group.dataset.revealStep);
    if (isNaN(step)) step = 0.1;
    var duration = parseFloat(group.dataset.revealDuration);
    if (isNaN(duration)) duration = 0.35;

    var entries = Array.prototype.map.call(items, function (el, i) {
      var order = el.hasAttribute('data-reveal-order')
        ? parseFloat(el.dataset.revealOrder)
        : i;
      return { el: el, start: baseDelay + order * step };
    });

    var ticking = false;

    function rawProgressFromWrapper() {
      var rect = wrapper.getBoundingClientRect();
      var scrollableHeight = rect.height - window.innerHeight;
      var progress = scrollableHeight > 0 ? -rect.top / scrollableHeight : 0;
      return Math.min(1, Math.max(0, progress));
    }

    // sequence-wrapper を持たない軽量セクション用：要素自体が画面下端から
    // 入ってくる進み具合を0〜1にする（画面高の60%分スクロールすると1に達する）
    function rawProgressFromEntrance() {
      var rect = group.getBoundingClientRect();
      var vh = window.innerHeight;
      var zone = vh * 0.6;
      var progress = (vh - rect.top) / zone;
      return Math.min(1, Math.max(0, progress));
    }

    function update() {
      var rawProgress = wrapper ? rawProgressFromWrapper() : rawProgressFromEntrance();
      var windowProgress = Math.min(1, Math.max(0, rawProgress / windowEnd));

      entries.forEach(function (entry) {
        var p;
        if (isReducedMotion) {
          p = windowProgress >= entry.start ? 1 : 0;
        } else {
          p = (windowProgress - entry.start) / duration;
          p = Math.min(1, Math.max(0, p));
        }
        entry.el.style.setProperty('--reveal-progress', p);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-reveal-group]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------- sequence-glow.js ---------- */
/**
 * セクション背景の光彩（.sbt-sequence-stage の radial-gradient）を
 * セクションごとに調整可能にするための軽量ブリッジ。
 * data-glow-* をCSSカスタムプロパティへコピーするだけで、実際の見た目は
 * input.css 側の color-mix() ベースの gradient が担当する。
 * カスタムプロパティは子孫へ継承されるため、.sbt-sequence-stage 側での
 * 追加の指定は不要（section に設定するだけで内部の stage に伝わる）。
 *
 * data-glow-color 等は --glow-color-pc へ、SP用の data-glow-color-sp 等は
 * --glow-color-sp へ、それぞれ "-pc"/"-sp" サフィックス付きの名前でコピーする
 * （実際に描画で使う --glow-color 自体はJSから直接は触らない）。
 * "実際に使う" --glow-color への割り当ては input.css 側で行う：
 *   [data-glow-color] { --glow-color: var(--glow-color-pc); }
 *   @media (max-width:767px) { [data-glow-color-sp] { --glow-color: var(--glow-color-sp); } }
 * こうする理由：JSが要素の inline style に直接 --glow-color を書いてしまうと、
 * インラインスタイルの優先度が非常に高いため、CSS側のメディアクエリで
 * 上書きしようとしても勝てない（外部スタイルシートはインラインに勝てない）。
 * "-pc"/"-sp" という別名にコピーするだけに留め、実際の切替（PC値かSP値か）は
 * 常に外部スタイルシート同士の勝負にすることで、メディアクエリでの上書きを可能にしている。
 *
 * DevToolsで数値を調整する場合は、対象の <section> 要素の
 * data-glow-* 属性、または --glow-color-pc / --glow-color-sp 等の
 * カスタムプロパティを直接編集する（--glow-color 自体を直接編集すると
 * インラインスタイルが優先されてしまい、ビューポートを跨いだ時に意図通り
 * 切り替わらなくなる点に注意）。
 */
(function () {
  'use strict';

  var ATTR_TO_VAR = {
    glowColor: '--glow-color-pc',
    glowSize: '--glow-size-pc',
    glowPos: '--glow-pos-pc',
    glowOpacity: '--glow-opacity-pc',
    glowColorSp: '--glow-color-sp',
    glowSizeSp: '--glow-size-sp',
    glowPosSp: '--glow-pos-sp',
    glowOpacitySp: '--glow-opacity-sp',
    // SP専用の暗転オーバーレイ（.section-overlay、上下グラデーション/均一暗転）。
    // PC側に同名の"アクティブ"変数が存在しないため、glowのような -pc/-sp の
    // 二段構え（インライン vs メディアクエリの優先度衝突を避ける仕組み）は不要で、
    // 直接 --overlay-*-sp へコピーしてよい（@media (max-width:767px) 内でのみ参照される）。
    overlayO1Sp: '--overlay-o1-sp',
    overlayO2Sp: '--overlay-o2-sp',
    overlayP1Sp: '--overlay-p1-sp',
    overlayP2Sp: '--overlay-p2-sp',
    overlayP3Sp: '--overlay-p3-sp',
  };

  function applyGlow(section) {
    Object.keys(ATTR_TO_VAR).forEach(function (key) {
      var value = section.dataset[key];
      if (value) {
        section.style.setProperty(ATTR_TO_VAR[key], value);
      }
    });
  }

  function init() {
    var selector = Object.keys(ATTR_TO_VAR)
      .map(function (key) {
        return '[data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase() + ']';
      })
      .join(',');
    document.querySelectorAll(selector).forEach(applyGlow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------- sequence-marker.js ---------- */
/**
 * ボルト強調マーカー（パルスマーカー + 固定ラベル + 伸縮する引き出し線）
 * .sbt-sequence-wrapper 単位で完全に独立して初期化される。
 *
 * 現在のフレーム番号（sequence.js と同じ計算式で算出）に応じて、
 * キーフレーム座標（data-marker-track-pc / data-marker-track-sp, JSON）を線形補間し、
 * .sbt-bolt-marker-layer を canvas の実描画サイズ（scale/originのtransform反映後）に
 * ピクセル単位で一致させて重ねる。そのため内側の座標(%指定)は常にcanvas基準で正しく重なる。
 *
 * 表示タイミングは4つの境界値で制御し、マーカー本体・引き出し線・ラベルの3者が
 * 常に同じopacityで連動する（同時にフェードイン/フェードアウトする）：
 *   data-marker-in        : フェードイン開始フレーム
 *   data-marker-in-end     : フェードイン完了 / 表示開始フレーム
 *   data-marker-out-start  : フェードアウト開始フレーム
 *   data-marker-out        : 完全非表示になるフレーム
 * data-marker-label="off" でラベル・引き出し線のみ無効化できる（マーカー本体は表示のまま）。
 *
 * ラベルはマーカーに追従せず、data-label-pos="X,Y"（canvas基準の%、left-center基準）で
 * 固定位置に配置する。引き出し線はマーカーの現在位置からラベルの固定位置まで、
 * SVGの<line>要素で毎フレーム再描画する（ボルトが動くにつれて線が伸縮する）。
 *
 * 座標データはこのファイル冒頭の SBT_MARKER_TRACKS に定数として持つ（項目数が多くschema向きでないため）。
 * セクション側は data-marker-key="fork" のようにキーだけを指定する。
 * 実機での微調整用に window.SBTBoltMarkers[セクションid] へ生データを公開しており、
 * ここを直接書き換えれば次のスクロールtickから反映される（再読み込み不要）。
 *
 * 見た目・演出関連の追加オプション：
 *   data-marker-size        : マーカーのサイズ（例 "56px"）。--marker-size に反映
 *   data-marker-flash       : "off" で無効化。既定は有効。data-marker-in を跨いだ瞬間に
 *                             背景を一瞬(0.3秒)暗くして視線をリセットする演出
 *   data-marker-burst-frame : 指定フレームを跨いだ瞬間に一度だけ大きく拡散するリングを出す
 *                             （分離完了の確定演出）。未指定なら発火しない
 * flash / burst はいずれも prefers-reduced-motion: reduce では発火しない。
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.SBTBoltMarkers = window.SBTBoltMarkers || {};

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function interpolateTrack(track, frame) {
    if (!track || !track.length) return null;
    if (frame <= track[0].frame) return { x: track[0].x, y: track[0].y };
    var last = track[track.length - 1];
    if (frame >= last.frame) return { x: last.x, y: last.y };
    for (var i = 0; i < track.length - 1; i++) {
      var a = track[i];
      var b = track[i + 1];
      if (frame >= a.frame && frame <= b.frame) {
        var t = (frame - a.frame) / (b.frame - a.frame);
        return { x: lerp(a.x, b.x, t), y: lerp(a.y, b.y, t) };
      }
    }
    return { x: last.x, y: last.y };
  }

  function computeOpacity(frame, inStart, inEnd, outStart, outEnd) {
    if (frame < inStart) return 0;
    if (frame < inEnd) return (frame - inStart) / Math.max(0.0001, inEnd - inStart);
    if (frame <= outStart) return 1;
    if (frame < outEnd) return 1 - (frame - outStart) / Math.max(0.0001, outEnd - outStart);
    return 0;
  }

  function crossedBoundary(prev, curr, boundary) {
    if (prev === null) return false;
    return (prev < boundary && curr >= boundary) || (prev >= boundary && curr < boundary);
  }

  function sortTrack(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.slice().sort(function (a, b) {
      return a.frame - b.frame;
    });
  }

  function parseTrack(json) {
    if (!json) return [];
    try {
      var data = JSON.parse(json);
      if (!Array.isArray(data)) return [];
      return data.slice().sort(function (a, b) {
        return a.frame - b.frame;
      });
    } catch (e) {
      console.warn('[sequence-marker] track JSON parse error:', e);
      return [];
    }
  }

  function initMarker(wrapper) {
    var markerEl = wrapper.querySelector('.sbt-bolt-marker');
    var layerEl = wrapper.querySelector('.sbt-bolt-marker-layer');
    var canvas = wrapper.querySelector('[data-seq-canvas]');
    var stageVisual = wrapper.querySelector('.sbt-stage-visual');
    if (!markerEl || !layerEl || !canvas || !stageVisual) return;

    var section = wrapper.closest('section');
    var id = (section && section.id) || wrapper.dataset.markerId || 'marker-' + Math.random().toString(36).slice(2);

    // 座標はファイル冒頭の SBT_MARKER_TRACKS から data-marker-key で引く。
    // data-marker-track-pc / -sp 属性があればそちらを優先する（単発の微調整用）。
    var key = wrapper.dataset.markerKey || id;
    var preset = (window.SBT_MARKER_TRACKS && window.SBT_MARKER_TRACKS[key]) || {};
    var trackPc = parseTrack(wrapper.dataset.markerTrackPc);
    if (!trackPc.length) trackPc = sortTrack(preset.pc);
    var trackSpParsed = parseTrack(wrapper.dataset.markerTrackSp);
    if (!trackSpParsed.length) trackSpParsed = sortTrack(preset.sp);
    if (!trackPc.length) return;

    var state = {
      pc: trackPc,
      sp: trackSpParsed.length ? trackSpParsed : trackPc,
    };
    window.SBTBoltMarkers[id] = state;

    var count = parseInt(wrapper.dataset.seqCount, 10) || 0;
    var start = parseFloat(wrapper.dataset.seqStart) || 0;
    var inStart = parseFloat(wrapper.dataset.markerIn);
    var inEnd = parseFloat(wrapper.dataset.markerInEnd);
    var outStart = parseFloat(wrapper.dataset.markerOutStart);
    var outEnd = parseFloat(wrapper.dataset.markerOut);
    if ([inStart, inEnd, outStart, outEnd].some(isNaN) || count < 1) return;

    var labelEnabled = wrapper.dataset.markerLabel !== 'off';
    var labelEl = wrapper.querySelector('.sbt-bolt-marker__label');
    var wireEl = wrapper.querySelector('.sbt-bolt-marker__wire');
    var lineEl = wrapper.querySelector('.sbt-bolt-marker__wire-line');

    var labelPos = null;
    if (labelEl && wrapper.dataset.labelPos) {
      var parts = wrapper.dataset.labelPos.split(',').map(parseFloat);
      if (parts.length === 2 && !parts.some(isNaN)) {
        labelPos = { x: parts[0], y: parts[1] };
        labelEl.style.left = labelPos.x + '%';
        labelEl.style.top = labelPos.y + '%';
      }
    }
    if (!labelPos) labelEnabled = false;

    if (wrapper.dataset.markerSize) {
      markerEl.style.setProperty('--marker-size', wrapper.dataset.markerSize);
    }

    var flashEnabled = wrapper.dataset.markerFlash !== 'off';
    var flashEl = wrapper.querySelector('.sbt-glow-flash');
    var burstFrame = parseFloat(wrapper.dataset.markerBurstFrame);
    var prevFrame = null;

    function triggerFlash() {
      if (!flashEl) return;
      flashEl.classList.add('is-active');
      setTimeout(function () {
        flashEl.classList.remove('is-active');
      }, 150);
    }

    function triggerBurst() {
      var burst = document.createElement('span');
      burst.className = 'sbt-bolt-marker__burst';
      markerEl.appendChild(burst);
      burst.addEventListener('animationend', function () {
        burst.remove();
      });
    }

    var ticking = false;

    function currentFrame() {
      var rect = wrapper.getBoundingClientRect();
      var scrollableHeight = rect.height - window.innerHeight;
      var rawProgress = scrollableHeight > 0 ? -rect.top / scrollableHeight : 0;
      rawProgress = Math.min(1, Math.max(0, rawProgress));
      var progress = start > 0 ? (rawProgress - start) / (1 - start) : rawProgress;
      progress = Math.min(1, Math.max(0, progress));
      return 1 + progress * (count - 1);
    }

    function update() {
      var mobileNow = window.innerWidth < MOBILE_BREAKPOINT;
      var track = mobileNow ? state.sp : state.pc;
      if (!track || !track.length) return;

      var canvasRect = canvas.getBoundingClientRect();
      var stageRect = stageVisual.getBoundingClientRect();
      if (canvasRect.width === 0) return;

      layerEl.style.width = canvasRect.width + 'px';
      layerEl.style.height = canvasRect.height + 'px';
      layerEl.style.transform =
        'translate(' + (canvasRect.left - stageRect.left) + 'px,' + (canvasRect.top - stageRect.top) + 'px)';

      var frame = currentFrame();
      var pos = interpolateTrack(track, frame);
      if (!pos) return;

      markerEl.style.left = pos.x + '%';
      markerEl.style.top = pos.y + '%';

      var opacity = computeOpacity(frame, inStart, inEnd, outStart, outEnd);
      markerEl.style.opacity = String(opacity);

      if (labelEnabled && labelEl && wireEl && lineEl) {
        labelEl.style.opacity = String(opacity);
        wireEl.style.opacity = String(opacity);
        lineEl.setAttribute('x1', String(pos.x));
        lineEl.setAttribute('y1', String(pos.y));
        lineEl.setAttribute('x2', String(labelPos.x));
        lineEl.setAttribute('y2', String(labelPos.y));
      }

      if (!isReducedMotion) {
        if (flashEnabled && crossedBoundary(prevFrame, frame, inStart)) {
          triggerFlash();
        }
        if (!isNaN(burstFrame) && crossedBoundary(prevFrame, frame, burstFrame)) {
          triggerBurst();
        }
      }
      prevFrame = frame;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // canvas は画像プリロード完了後に実サイズへリサイズされる（is-ready付与と同時）。
    // 初期化時点ではまだ既定サイズ(300x150)のことがあるため、変化を検知して再同期する。
    new MutationObserver(update).observe(canvas, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('.sbt-sequence-wrapper[data-marker-key], .sbt-sequence-wrapper[data-marker-track-pc]').forEach(initMarker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
